var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useMemo, useRef, useState } from 'react';
import { useConfig } from '../context/ConfigContext';
import { useFetch } from './useFetch';
import { fetchSpaceApproveReservationPermission } from '../api/bookingApprovalPermissionClient';
export function normalizeApprovalPermissionIds(orgId, managedSpaceId) {
    return {
        orgIdStr: orgId != null && orgId !== '' ? String(orgId) : '',
        spaceIdStr: managedSpaceId != null && managedSpaceId !== ''
            ? String(managedSpaceId)
            : '',
    };
}
export function useApprovalPermission(_a) {
    var orgId = _a.orgId, managedSpaceId = _a.managedSpaceId;
    var _b = useConfig(), environmentUrls = _b.environmentUrls, tenantId = _b.tenantId, accessToken = _b.accessToken;
    var baseApiUrl = environmentUrls.baseApiUrl;
    var post = useFetch(accessToken).post;
    var _c = __read(useState(false), 2), canApprove = _c[0], setCanApprove = _c[1];
    var _d = __read(useState(false), 2), loading = _d[0], setLoading = _d[1];
    var _e = __read(useState(null), 2), error = _e[0], setError = _e[1];
    var requestIdRef = useRef(0);
    var _f = normalizeApprovalPermissionIds(orgId, managedSpaceId), orgIdStr = _f.orgIdStr, spaceIdStr = _f.spaceIdStr;
    useEffect(function () {
        if (!orgIdStr || !spaceIdStr) {
            setCanApprove(false);
            setLoading(false);
            setError(null);
            return;
        }
        var controller = new AbortController();
        var requestId = ++requestIdRef.current;
        var cancelled = false;
        setLoading(true);
        setError(null);
        fetchSpaceApproveReservationPermission({
            orgId: orgIdStr,
            managedSpaceId: spaceIdStr,
            baseApiUrl: baseApiUrl,
            tenantId: tenantId,
            post: post,
            signal: controller.signal,
        })
            .then(function (permitted) {
            if (cancelled || requestId !== requestIdRef.current) {
                return;
            }
            setCanApprove(permitted);
            setLoading(false);
            setError(null);
        })
            .catch(function (err) {
            if (cancelled || requestId !== requestIdRef.current) {
                return;
            }
            if (err instanceof Error && err.name === 'AbortError') {
                return;
            }
            setCanApprove(false);
            setLoading(false);
            setError(err instanceof Error ? err : new Error(String(err)));
        });
        return function () {
            cancelled = true;
            controller.abort();
        };
    }, [orgIdStr, spaceIdStr, baseApiUrl, tenantId, post]);
    return useMemo(function () { return ({ canApprove: canApprove, loading: loading, error: error }); }, [canApprove, loading, error]);
}
